import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const ANCHORABLE_PLUGIN_NODES = [
  Node_Type.IMAGE,
  Node_Type.GALLERY,
  Node_Type.VIDEO,
  Node_Type.BUTTON,
  Node_Type.GIF,
  Node_Type.FILE
];
const ANCHORABLE_TEXT_NODES = [
  Node_Type.PARAGRAPH,
  Node_Type.BLOCKQUOTE,
  Node_Type.CODE_BLOCK,
  Node_Type.HEADING
];
export {
  ANCHORABLE_PLUGIN_NODES,
  ANCHORABLE_TEXT_NODES
};
//# sourceMappingURL=constants.js.map
